import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

const GreetingModal = ({ show, handleClose, onSave, greeting }) => {
  const [showNewTextarea, setShowNewTextarea] = useState(false);
  const [textareaContent, setTextareaContent] = useState(greeting || "");
  const [charCount, setCharCount] = useState(greeting?.length || 0);
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const greetingOptions = [
    {
      text: "Thank you for calling Royal Cyber Inc. This is Nouraa. How may I help you?",
    },
    {
      text: "Hello, you've reached Royal Cyber Inc. I'm Nouraa. How may I assist you today?",
    },
    {
      text: "Hi, it's a great day here at Royal Cyber Inc. This is Nouraa. How may I help you?",
    },
  ];

  // Initialize the textarea content with the preloaded greeting
  useEffect(() => {
    if (greeting) {
      setTextareaContent(greeting);
      setCharCount(greeting.length);
    }
  }, [greeting]);

  const handleExpandTextarea = () => {
    setShowNewTextarea(true);
  };

  const handleTextareaChange = (event) => {
    const content = event.target.value;
    setTextareaContent(content);
    setCharCount(content.length);
    setIsSaveEnabled(
      content.length > 0 && content.length <= 200 && isCheckboxChecked
    );
    setErrorMessage(content.length > 200 ? "Character limit exceeded" : "");
  };

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setIsCheckboxChecked(isChecked);
    setIsSaveEnabled(
      textareaContent.length > 0 && textareaContent.length <= 200 && isChecked
    );
  };

  const handleSave = async () => {
    if (textareaContent.length > 200) {
      setErrorMessage("Character limit exceeded");
      return;
    }
    if (!isCheckboxChecked) {
      setErrorMessage("Please acknowledge liability");
      return;
    }

    setIsLoading(true);
    try {
      await onSave(textareaContent); // Save the new greeting
      handleModalClose();
    } catch (error) {
      setErrorMessage("Failed to save greeting. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleModalClose = () => {
    setShowNewTextarea(false);
    setTextareaContent(greeting || ""); // Reset to the preloaded greeting
    setCharCount(greeting?.length || 0);
    setIsSaveEnabled(false);
    setIsCheckboxChecked(false);
    setErrorMessage("");
    handleClose();
  };

  const handleEditClick = (text) => {
    setTextareaContent(text);
    setCharCount(text.length);
    setShowNewTextarea(true);
  };

  return (
    <Modal show={show} onHide={handleModalClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="fs-three bg-light">
          Greeting Customization
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {greetingOptions.map((option, index) => (
            <div
              key={index}
              className="d-flex align-items-start my-3 p-3 border border-light-subtle rounded-3"
            >
              <img
                src="/assets/quote-solid.svg"
                alt="Left Icon"
                className="me-2 bg-icon p-2 align-self-start"
              />
              <span className="flex-grow-1 pre-greeting-text">
                {option.text}
              </span>
              <img
                src="/assets/edit-2.svg"
                alt="Right Icon"
                className="ms-3"
                style={{ cursor: "pointer" }}
                onClick={() => handleEditClick(option.text)}
              />
            </div>
          ))}
        </div>
        <div className="position-relative mb-3">
          <Link
            to="#"
            className="form-control greeting-modal-textarea text-decoration-none purple-color fw-bold"
            style={{ paddingLeft: "40px", display: "block" }}
            onClick={handleExpandTextarea}
          >
            <img
              src="/assets/edit-1.svg"
              alt="Write Icon"
              className="position-absolute"
              style={{ top: "10px", left: "10px" }}
            />
            Write Greeting
          </Link>
          {showNewTextarea && (
            <div className="position-relative greeting-modal-textarea border-top-0 p-3  rounded-3">
              <p className="mb-3 gray-color">
                Naura records all calls for you. Use of this system is subject
                to state and federal laws applying to call recording. By
                customizing your greeting, you assume liability for disclosing
                this to your callers.
              </p>
              <textarea
                placeholder="e.g. Thank you for calling royal Cyber Inc. This is the AI Voice Assistant on a recorded line. How may I help you?"
                className="form-control"
                rows="5"
                cols="100"
                value={textareaContent}
                onChange={handleTextareaChange}
              />
              <p className="mt-2 gray-color fs-one">
                {200 - charCount} characters remaining
                {errorMessage && (
                  <span className="text-danger fs-one ms-2">
                    {errorMessage}
                  </span>
                )}
              </p>
              <Form.Check
                type="checkbox"
                label="I acknowledge that I assume liability for call recording disclosure."
                className="mt-2 fw-bold custom-checkbox"
                onChange={handleCheckboxChange}
              />
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <img src="/assets/flag.svg" alt="Info" className="me-2" />
          <Link
            to=""
            className="fs-one text-decoration-none purple-color fw-bold"
          >
            Report pronunciation issue
          </Link>
        </div>
        <div className="d-flex align-items-center">
          <span className="me-3 fs-one gray-color">
            Changes will go live immediately
          </span>
          <Button className="fw-bold" variant="none" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            className="ms-2 bg-purple-color fw-bold greeting-save-btn"
            disabled={!isSaveEnabled || isLoading}
          >
            {isLoading ? <Spinner animation="border" size="sm" /> : "Save"}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default GreetingModal;
